<template>
  <Container isHome>
    <template v-slot:body>
      <div class="home-grid">
        <section class="home-welcome">
          <div class="welcome-kicker">
            <span class="kicker-dot"></span>
            <span>Welcome to Bohm Technologies</span>
          </div>
          <h1>Welcome to<br /><span>Bohm.</span></h1>
          <p class="home-lede">
            Here for a meeting or a delivery? Choose an option and we’ll get you
            where you need to go.
          </p>

          <div class="welcome-visual" aria-hidden="true">
            <div class="visual-sun"></div>
            <div class="visual-card visual-card--back"></div>
            <div class="visual-card visual-card--front">
              <div class="visual-card-top">
                <span class="visual-logo-mark">b</span>
                <span>VISITOR PASS</span>
              </div>
              <div class="visual-line visual-line--long"></div>
              <div class="visual-line visual-line--short"></div>
              <div class="visual-pass-footer">
                <span>BOHM TECHNOLOGIES</span>
                <IconGlyph name="check" :size="18" />
              </div>
            </div>
            <div class="visual-caption">
              <span class="caption-number">01</span>
              <span>Fast in.<br />Friendly start.</span>
            </div>
          </div>

          <div class="trust-row">
            <span class="trust-icon"
              ><IconGlyph name="shield" :size="20"
            /></span>
            <span
              ><strong>Quick &amp; secure</strong
              ><small>Your privacy matters to us.</small></span
            >
          </div>
        </section>

        <section class="home-actions" aria-label="Visit options">
          <div class="actions-heading">
            <span class="section-overline">Start here</span>
            <h2>What brings you in?</h2>
            <p>Choose an option to get started.</p>
          </div>

          <div class="action-list">
            <button
              class="action-card action-card--orange"
              type="button"
              @click="$router.push('/guest')"
            >
              <span class="action-icon"
                ><IconGlyph name="user" :size="25"
              /></span>
              <span class="action-card-copy">
                <strong>Sign in as a visitor</strong>
                <small>Meeting someone at Bohm?</small>
              </span>
              <span class="action-arrow"
                ><IconGlyph name="arrow-right" :size="20"
              /></span>
            </button>

            <button
              class="action-card action-card--gold"
              type="button"
              @click="$router.push('/pickup')"
            >
              <span class="action-icon"
                ><IconGlyph name="package" :size="25"
              /></span>
              <span class="action-card-copy">
                <strong>Pickup or delivery</strong>
                <small>For carriers and scheduled drops.</small>
              </span>
              <span class="action-arrow"
                ><IconGlyph name="arrow-right" :size="20"
              /></span>
            </button>
          </div>

          <div class="actions-note">
            <span class="note-check"><IconGlyph name="check" :size="14"/></span>
            <span>No account or app needed</span>
            <span class="note-separator"></span>
            <span>Takes less than a minute</span>
          </div>
        </section>
      </div>
    </template>
  </Container>
</template>

<script>
import Container from "@/components/Container";
import IconGlyph from "@/components/IconGlyph";

export default {
  name: "Home",
  components: { Container, IconGlyph }
};
</script>

<style>
.home-grid {
  display: grid;
  grid-template-columns: minmax(0, 0.91fr) minmax(470px, 1.09fr);
  align-items: center;
  gap: clamp(50px, 8vw, 150px);
  min-height: calc(100vh - 210px);
}

.home-welcome {
  padding: 20px 0 24px clamp(12px, 3vw, 50px);
}

.welcome-kicker,
.section-overline {
  color: var(--orange);
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.welcome-kicker {
  display: flex;
  align-items: center;
  gap: 9px;
}

.kicker-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--orange);
  box-shadow: 0 0 0 5px rgba(233, 86, 53, 0.12);
}

.home-welcome h1 {
  max-width: 560px;
  margin: 22px 0 18px;
  color: var(--ink);
  font-family: Eurosoft, -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  font-size: clamp(48px, 5.4vw, 82px);
  font-weight: 500;
  letter-spacing: -0.055em;
  line-height: 0.94;
}

.home-welcome h1 span {
  color: var(--orange);
}

.home-lede {
  max-width: 450px;
  margin: 0;
  color: var(--muted);
  font-size: 16px;
  line-height: 1.65;
}

.welcome-visual {
  position: relative;
  width: min(100%, 440px);
  height: 157px;
  margin: 38px 0 26px 6px;
}

.visual-sun {
  position: absolute;
  top: 6px;
  left: 4px;
  width: 142px;
  height: 142px;
  border-radius: 50%;
  background: #f5d48d;
}

.visual-sun::after {
  position: absolute;
  right: -14px;
  bottom: 2px;
  width: 61px;
  height: 61px;
  border: 9px solid var(--paper);
  border-radius: 50%;
  background: var(--orange);
  content: "";
}

.visual-card {
  position: absolute;
  width: 206px;
  height: 126px;
  border-radius: 15px;
  transform: rotate(-6deg);
}

.visual-card--back {
  top: 18px;
  left: 92px;
  background: #e8c9a7;
  opacity: 0.72;
  transform: rotate(9deg);
}

.visual-card--front {
  top: 14px;
  left: 80px;
  padding: 16px 17px 13px;
  box-sizing: border-box;
  background: var(--white);
  box-shadow: 0 18px 34px rgba(30, 41, 42, 0.15);
}

.visual-card-top,
.visual-pass-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.visual-card-top {
  color: var(--muted);
  font-size: 7px;
  font-weight: 900;
  letter-spacing: 0.17em;
}

.visual-logo-mark {
  display: grid;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  background: var(--orange);
  color: white;
  font-family: Georgia, serif;
  font-size: 17px;
  place-items: center;
}

.visual-line {
  height: 5px;
  margin-top: 19px;
  border-radius: 99px;
  background: #e5e4dc;
}

.visual-line--long {
  width: 118px;
}

.visual-line--short {
  width: 74px;
  margin-top: 9px;
  background: #f3dfd6;
}

.visual-pass-footer {
  position: absolute;
  right: 17px;
  bottom: 13px;
  left: 17px;
  color: var(--accent);
  font-size: 7px;
  font-weight: 900;
  letter-spacing: 0.08em;
}

.visual-pass-footer .icon-glyph {
  padding: 4px;
  border-radius: 50%;
  background: var(--accent-soft);
}

.visual-caption {
  position: absolute;
  top: 38px;
  left: 314px;
  display: flex;
  align-items: flex-start;
  gap: 9px;
  color: var(--muted);
  font-size: 11px;
  font-weight: 700;
  line-height: 1.35;
}

.caption-number {
  color: var(--orange);
  font-size: 10px;
  font-weight: 900;
}

.trust-row {
  display: flex;
  align-items: center;
  gap: 11px;
  color: var(--muted);
  font-size: 12px;
}

.trust-icon {
  display: grid;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: var(--accent-soft);
  color: var(--accent);
  place-items: center;
}

.trust-row span:last-child {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.trust-row strong {
  color: var(--ink);
  font-size: 12px;
}

.trust-row small {
  color: var(--muted);
  font-size: 11px;
}

.home-actions {
  width: min(100%, 620px);
  justify-self: end;
}

.actions-heading {
  margin-bottom: 21px;
}

.actions-heading h2 {
  margin: 9px 0 5px;
  color: var(--ink);
  font-size: 27px;
  font-weight: 800;
  letter-spacing: -0.035em;
}

.actions-heading p {
  margin: 0;
  color: var(--muted);
  font-size: 14px;
}

.action-list {
  display: grid;
  gap: 12px;
}

.action-card {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 94px;
  padding: 16px 19px 16px 16px;
  border: 0;
  border-radius: 19px;
  color: white;
  text-align: left;
  cursor: pointer;
  box-shadow: 0 10px 20px rgba(30, 41, 42, 0.05);
  transition: transform 160ms ease, box-shadow 160ms ease;
}

.action-card:hover,
.action-card:focus-visible {
  transform: translateY(-2px);
  box-shadow: 0 15px 25px rgba(30, 41, 42, 0.13);
  outline: none;
}

.action-card:active {
  transform: translateY(0);
}

.action-card--orange {
  background: var(--orange);
}

.action-card--accent {
  background: var(--accent);
}

.action-card--gold {
  background: #d59e42;
}

.action-icon {
  display: grid;
  width: 57px;
  height: 57px;
  margin-right: 17px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.18);
  place-items: center;
}

.action-card-copy {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 7px;
}

.action-card-copy strong {
  font-size: 16px;
  font-weight: 850;
  letter-spacing: -0.015em;
}

.action-card-copy small {
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
}

.action-arrow {
  display: grid;
  width: 33px;
  height: 33px;
  margin-left: 12px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 50%;
  place-items: center;
}

.actions-note {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
  color: var(--muted);
  font-size: 11px;
  font-weight: 700;
}

.note-check {
  display: grid;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--accent-soft);
  color: var(--accent);
  place-items: center;
}

.note-separator {
  width: 3px;
  height: 3px;
  margin: 0 3px;
  border-radius: 50%;
  background: #b6bfba;
}

@media (max-width: 980px) {
  .home-grid {
    grid-template-columns: 1fr;
    gap: 22px;
    min-height: 0;
  }

  .home-welcome {
    padding-left: 0;
  }

  .home-lede {
    max-width: 570px;
  }

  .welcome-visual {
    margin-top: 24px;
  }

  .home-actions {
    width: 100%;
    justify-self: stretch;
  }
}

@media (max-width: 620px) {
  .home-welcome h1 {
    font-size: 52px;
  }

  .welcome-visual {
    transform: scale(0.84);
    transform-origin: left center;
    margin-top: 5px;
    margin-bottom: -13px;
  }

  .action-card {
    min-height: 88px;
  }
}

@media (orientation: landscape) and (min-width: 768px) and (max-height: 820px) {
  .home-grid {
    min-height: calc(100vh - 152px);
  }

  .home-welcome {
    padding-top: 0;
    padding-bottom: 0;
  }

  .home-welcome h1 {
    margin-top: 16px;
    margin-bottom: 12px;
    font-size: 54px;
  }

  .welcome-visual {
    height: 120px;
    margin-top: 20px;
    margin-bottom: 16px;
    transform: scale(0.82);
    transform-origin: left center;
  }

  .action-card {
    min-height: 76px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .action-icon {
    width: 48px;
    height: 48px;
  }

  .actions-heading {
    margin-bottom: 15px;
  }

  .actions-note {
    margin-top: 13px;
  }
}
</style>
